// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"du-z","slideIn":"eu-z"};